const YOMDEL_ID = "yomdel-script";

function loadYomdel(url) {
  if (typeof window === "undefined") return;
  if (window.YOMDEL_LOADED) return;
  window.YOMDEL_LOADED = true;

  if (document.getElementById(YOMDEL_ID)) return;

  const script = document.createElement("script");
  script.id = YOMDEL_ID;
  script.type = "text/javascript";
  script.async = true;
  script.src = `https://clients.yomdel.com/tools/chat_script.js?url=${encodeURIComponent(
    url
  )}`;

  document.body.appendChild(script);
}

function scheduleYomdelLoad(url) {
  if (typeof window === "undefined" || window.YOMDEL_LOADED) return;

  const callback = () => loadYomdel(url);
  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(callback, { timeout: 3000 });
  } else {
    window.setTimeout(callback, 3000);
  }
}

// Delay chat script loading until after initial rendering
export const onClientEntry = () => {
  if (typeof window === "undefined") return;
  scheduleYomdelLoad(window.location.href);
};

// Route change (SPA navigation)
export const onRouteUpdate = ({ location }) => {
  if (typeof window === "undefined") return;

  scheduleYomdelLoad(location.href);
};